import Actions from "@/elements/Actions";
import { cn } from "@/lib/utils";
import Image from "next/image";
import React from "react";
import BuySellBtn from "../PlaceOrder/BuySellBtn";
import { Button } from "../ui/button";
import tradingView from "@/assets/icons/tradingview.svg";
import WatchListButton from "./WatchListButton";
import Hint from "../Hint";
import { Mixpanel } from "@/elements/Mixpanel";
import { getInstrument } from "@/lib/tradeCards";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";

export default function OnHoverOption({
    isOption = false,
    watchListIds,
    finCode,
    exchange,
    nseSymbol,
    bseSymbol,
    isOpen,
    setOpen,
    className,
    source,
    callBack = () => {},
    onClickTradingView = () => {},
    disableBuySell = false
}) {
    const { userData } = useSelector((state) => state.userDetails);

    const { replace } = useRouter();
    return (
        <div
            className={cn(
                "absolute top-1/2 right-0 -translate-y-1/2 transition-all flex items-center gap-2 opacity-0 group-hover:opacity-100 group-hover:right-4 z-[1]",
                className,
                { "opacity-100 right-4": isOpen }
            )}
        >
            {!userData?.id && (
                <div
                    className=" absolute top-0 left-0 right-0 bottom-0 z-[2]"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        replace("/user/log-in");
                    }}
                />
            )}
            <BuySellBtn
                disabled={disableBuySell}
                type="BUY"
                finCode={finCode}
                exchange={exchange}
                callBack={callBack}
                symbol={nseSymbol ?? bseSymbol}
                pageName={source}
            />
            <BuySellBtn
                disabled={disableBuySell}
                type="SELL"
                finCode={finCode}
                exchange={exchange}
                callBack={callBack}
                symbol={nseSymbol ?? bseSymbol}
                pageName={source}
            />
            <Hint label="Trading view" side="top">
                <Button
                    variant="outline"
                    className="w-7 h-7 p-0.5 bg-[#fff] hover:bg-[#FFFFFFBF] "
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        callBack();
                        Mixpanel.track("cta_clicked", {
                            page: source,
                            cta_text: "view_chart",
                            symbol: nseSymbol || bseSymbol,
                            expiry_date: null,
                            instrument_name: getInstrument(nseSymbol || bseSymbol),
                            source: source
                        });
                        onClickTradingView();
                    }}
                >
                    <Image src={tradingView} alt="tradingView" className="w-full object-contain hover:opacity-75" />
                </Button>
            </Hint>
            {/* {!isOption && (
                <Button
                    variant="outline"
                    className="w-7 h-7 p-1 bg-[#fff] hover:bg-[#fff] "
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        callBack();
                        router.push(Actions.toStockDetail(nseSymbol ?? bseSymbol, exchange));
                    }}
                >
                    <MdInsertLink className="w-6 h-6" color="#606060" />
                </Button>
            )} */}
            <WatchListButton
                className="w-7 h-7 flex justify-center items-center rounded border"
                watchListIds={watchListIds}
                finCode={finCode}
                exchange={exchange}
                size="16px"
                setParentOpen={setOpen}
                symbol={nseSymbol ?? bseSymbol}
                pageName={source}
            />
        </div>
    );
}
